import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openReportById } from '../../scenes/Gnosus/scenes/Report/actions'
import { openLinkagesById } from '../../scenes/Gnosus/scenes/Linkages/actions'
import { setupDistraintsById } from '../../scenes/Gnosus/scenes/Distraints/actions'

export function mapStateToProps(state, hocProps) {
    return {
        isContextMenuShow: state.getIn(['contextMenu', `contextMenu_${hocProps.entity.get('entId')}`, 'show'], false),
        activeEntityStackTab: state.getIn(['ui', 'entityStack', 'tabs', 'activeTab'], null),
        activeModule: state.getIn(['ui', 'moduleMenu', 'active']),
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openReportById, openLinkagesById, setupDistraintsById }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
